export default () => {
    return {
        video: {
            name: 'Video Section',
            name_markup: '<h2><strong>Video Section</strong></h2>',
            type: 'video-component',
            section_content: {
                description: '<p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout</p>',
                link: 'https://www.youtube.com/embed/k2m2g3U0KIQ',
                embed: '',
                html: '<p>Lorem Ipsum Lorem Ipsum Lorem Lorem Ipsum Lorem Ipsum Lorem Lorem</p>',
            },
        },
        text: {
            name: 'Content Headline',
            name_markup: '<h2><strong>Content Headline</strong></h2>',
            type: 'content-component',
            section_content: {
                html: '<p>Lorem Ipsum Lorem Ipsum Lorem Lorem Ipsum Lorem Ipsum Lorem Lorem Ipsum Lorem Ipsum Lorem Lorem Ipsum Lorem Ipsum Lorem Lorem Ipsum Lorem Ipsum Lorem Lorem Ipsum Lorem Ipsum Lorem Lorem Ipsum Lorem Ipsum Lorem Lorem Ipsum</p>',
            },
        },
        checklist: {
            name: 'Key Lessons Include',
            name_markup: '<h2><strong>Key Lessons Include</strong></h2>',
            type: 'checklist-component',
            section_content: {
                viewType: 'grid',
                items: [
                    '<p>Lorem Ipsum Lorem Ipsum Lorem.</p>',
                    '<p>Lorem Ipsum Lorem Ipsum Lorem.</p>',
                ],
            },
        },
        accordion: {
            name: 'Accordion Headline',
            name_markup: '<h2><strong>Accordion Headline</strong></h2>',
            type: 'accordion-component',
            section_content: {
                items: [
                    { title: '<h3>Title</h3>', description: '<p>Description</p>', isCollapsed: false }
                ]
            }
        },
        download: {
            name: 'Download Headline',
            name_markup: '<h2><strong>Download Headline</strong></h2>',
            type: 'download-component',
            section_content: {
                viewType: 'grid',
                showInSidebar: false,
                items: []
            }
        },
        pdf: {
            name: 'PDF Headline',
            name_markup: '<h2><strong>PDF Headline</strong></h2>',
            type: 'pdf-component',
            section_content: {
                viewType: 'list',
                items: []
            }
        },
        audio: {
            name: 'Audio Headline',
            name_markup: '<h2><strong>Audio Headline</strong></h2>',
            type: 'audio-component',
            section_content: {
                items: [],
            },
        },
    };
};